module.exports = __webpack_public_path__ + "static/home-seo-c1a7f8b83b6cbc54f0202b9fc1b346de.png";